const dltrack = data => {
  if (typeof window !== 'undefined') {
    try {
      window.dataLayer.push(data)
    } catch (err) {
      console.log(err)
    }
  }
}

export { dltrack }
